<template>
  <div class="calendarNoteCreate">
    <h1 class="calendarNoteCreate__title hidden-mobile-down">
      <span>{{ nowMode === "AstroCalendarNoteEdit" ? "編輯" : "建立" }}</span>
      共时历笔记
    </h1>
    <div class="calendarNoteCreate__box" v-if="currentInterpretation">
      <div class="calendarNoteCreate__box__detail">
        <div class="calendarNoteCreate__box__detail__picArea">
          <img :src="topicImg" alt="" />
        </div>

        <div class="calendarNoteCreate__box__detail__date">
          {{ moment(editDate).format("MM/DD") }}
          <span>{{ moment(editDate).format("ddd") }}</span>
        </div>

        <div class="calendarNoteCreate__box__detail__highlight">
          ★ {{ currentInterpretation.Highlight }}
        </div>
      </div>

      <div class="calendarNoteCreate__box__switchDate">
        <div>写下你在这天的观察吧：）</div>
        <div
          class="calendarNoteCreate__box__switchDate__btn"
          @click="dateModal = true"
        >
          <img src="@/assets//共時曆/swichDateIcon.svg" alt="" />
          <span>切换时间</span>
        </div>
      </div>
      <v-dialog ref="dialog" v-model="dateModal" width="290px" persistent>
        <v-date-picker
          class="picker date-picker"
          v-model="temp_date"
          :first-day-of-week="0"
          locale="zh-cn"
          scrollable
          header-color="rgba(217, 217, 217, 0.25)"
          color="primary"
          max="2200-12-31"
          min="1910-01-01"
        >
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dateModal = false">取消</v-btn>
          <v-btn text color="error" @click="saveDateTime()">确认</v-btn>
        </v-date-picker>
      </v-dialog>

      <!-- 這天寫過了 -->
      <div
        class="calendarNoteCreate__box__notice"
        v-if="showAlreadyWriteNotice"
      >
        <img src="../../assets/月亮日記/紅底驚嘆號.svg" alt="" />
        <div>
          你已经写过
          <span>{{ astroCalendarNoteEdit.Title }} ({{ editDate }})</span>
          的笔记，已经无法再新增。请选择其它日期来建立笔记喔！
        </div>
      </div>
      <div class="calendarNoteCreate__box__line"></div>
      <div class="calendarNoteCreate__box__input">
        <div class="calendarNoteCreate__box__input__title">你的心情如何呢</div>
        <div class="calendarNoteCreate__box__input__selectEmotion">
          <div
            class="calendarNoteCreate__box__input__selectEmotion__item"
            v-for="item in emotionList"
            :key="item.id"
          >
            <div
              class="calendarNoteCreate__box__input__selectEmotion__item__pic"
              :class="{ active: splitMoods.includes(item.id) }"
              :style="`background-color:${
                splitMoods.includes(item.id) ? item.color : ''
              } `"
              @click="moodsHandler(item.id)"
            >
              <img
                :src="item.active_icon"
                v-if="splitMoods.includes(item.id)"
              />
              <img :src="item.normal_icon" v-else />
            </div>
            <div
              class="calendarNoteCreate__box__input__selectEmotion__item__label"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <textarea
          class="detail area1"
          cols="30"
          v-model="MoodContent"
          placeholder="來寫下今天的心情吧 :)"
          maxlength="50"
        ></textarea>
        <span>上限为 50 个字 ({{ MoodContent.length }}/50)</span>
      </div>
      <div class="calendarNoteCreate__box__input">
        <div class="calendarNoteCreate__box__input__title">写下今日笔记</div>
        <textarea
          class="detail area2"
          cols="30"
          v-model="Content"
          placeholder="來寫寫今日的筆記吧 :)"
          maxlength="500"
        ></textarea>
        <span>上限为 500 个字 ({{ Content.length }}/500)</span>
      </div>
      <div class="calendarNoteCreate__box__btn">
        <div class="calendarNoteCreate__box__btn__cancel" @click="cancel">
          取消
        </div>
        <div
          class="calendarNoteCreate__box__btn__ok"
          :class="{
            disable: showAlreadyWriteNotice,
          }"
          @click="save"
        >
          {{ nowMode === "AstroCalendarNoteEdit" ? "儲存" : "建立" }}
        </div>
      </div>
    </div>
    <div v-else>loading</div>
  </div>
</template>

<script>
import moment from "moment";
import emotionList from "@/js/emotionList.js";
export default {
  data() {
    return {
      emotionList,
      dateModal: false,
      temp_date: this.$store.getters.astroCalendarNoteEdit.Date,
      showAlreadyWriteNotice: false,
      currentInterpretation: "",
      constellation: [
        { name: "牡羊", img: require("@/assets/constellations/con_1.svg") },
        { name: "金牛", img: require("@/assets/constellations/con_2.svg") },
        { name: "雙子", img: require("@/assets/constellations/con_3.svg") },
        { name: "巨蟹", img: require("@/assets/constellations/con_4.svg") },
        { name: "獅子", img: require("@/assets/constellations/con_5.svg") },
        { name: "處女", img: require("@/assets/constellations/con_6.svg") },
        { name: "天秤", img: require("@/assets/constellations/con_7.svg") },
        { name: "天蠍", img: require("@/assets/constellations/con_8.svg") },
        { name: "射手", img: require("@/assets/constellations/con_9.svg") },
        { name: "摩羯", img: require("@/assets/constellations/con_10.svg") },
        { name: "水瓶", img: require("@/assets/constellations/con_11.svg") },
        { name: "雙魚", img: require("@/assets/constellations/con_12.svg") },
      ],
    };
  },
  async created() {
    this.$store.commit("setLoading_force", true);
    await this.init();
    this.$store.commit("setLoading_force", false);
  },
  computed: {
    nowUserData() {
      return this.$store.state.nowUserData;
    },
    astroCalendarNoteEdit() {
      return this.$store.getters.astroCalendarNoteEdit;
    },
    nowMode() {
      return this.$route.name == "AstroCalendarNoteEdit"
        ? "AstroCalendarNoteEdit"
        : "AstroCalendarNoteCreate";
    },
    Content: {
      get() {
        return this.$store.getters.astroCalendarNoteEdit.Content;
      },
      set(val) {
        this.$store.commit("setAstroCalendarNoteEdit", {
          Content: val,
        });
      },
    },
    Moods: {
      get() {
        return this.$store.getters.astroCalendarNoteEdit.Moods || "";
      },
      set(val) {
        this.$store.commit("setAstroCalendarNoteEdit", {
          Moods: val,
        });
      },
    },
    splitMoods() {
      return this.Moods ? this.Moods.split("|") : [];
    },
    MoodContent: {
      get() {
        return this.$store.getters.astroCalendarNoteEdit.MoodContent;
      },
      set(val) {
        this.$store.commit("setAstroCalendarNoteEdit", {
          MoodContent: val,
        });
      },
    },
    editDate: {
      get() {
        return moment(this.$store.getters.astroCalendarNoteEdit.Date).format(
          "YYYY-MM-DD"
        );
      },
      set(val) {
        this.$store.commit("setAstroCalendarNoteEdit", {
          Date: val,
        });
      },
    },
    topicImg() {
      if (
        !this.currentInterpretation ||
        !this.currentInterpretation.Highlight
      ) {
        return require("@/assets/constellations/con_1.svg");
      }
      let target = this.constellation.find((item) =>
        this.currentInterpretation.Highlight.includes(item.name)
      );
      return target ? target.img : require("@/assets/constellations/con_1.svg");
    },
  },
  methods: {
    moment,
    async init() {
      if (this.$route.name === "AstroCalendarNoteEdit") {
        // 編輯模式
        await this.getEditData(this.$route.params.CalendarNoteId);
      } else {
        // 建立模式
        if (!this.astroCalendarNoteEdit.Date) {
          return this.$router.replace("/astroCalendar");
        }
        await this.checkAleardyWrite();
      }
      await this.getTitleByDate();

    },
    cancel() {
      this.$router.go(-1);
    },
    async save() {
      if (!this.Content || !this.MoodContent || !this.Moods) {
        this.$messagePopup(
          "您還有未填寫的內容喔",
          "再檢查一下，看有沒有確實選好「心情圖示」，並完成「心情」與「今日筆記」的記錄喔～",
          "瞭解"
        );
        return;
      }
      if (this.nowMode === "AstroCalendarNoteCreate") {
        delete this.astroCalendarNoteEdit.CalendarNoteId;

        if (await this.checkAleardyWrite()) {
          this.$store.commit("setShowCalendarNoteAlreadyWrite", true);
        } else {
          let arg = JSON.parse(JSON.stringify(this.astroCalendarNoteEdit));
          delete arg.Title;
          this.$API
            .POST_CalendarNote(this.astroCalendarNoteEdit)
            .then(({ data }) => {
              this.$store.commit("update_toast", ["已成功建立筆記"]);
              this.$router.push(`/astroCalendar?date=${arg.Date}`);
            })
            .catch(() => {
              this.$messagePopup("建立失敗", "請稍後再試", "了解", () =>
                this.$router.go(-1)
              );
            });
        }
      } else {
        this.$API
          .POST_CalendarNote({
            CalendarNoteId: this.astroCalendarNoteEdit.CalendarNoteId,
            Content: this.astroCalendarNoteEdit.Content,
            MoodContent: this.astroCalendarNoteEdit.MoodContent,
            Moods: this.astroCalendarNoteEdit.Moods,
            Date: moment(this.astroCalendarNoteEdit.Date).format("YYYY-MM-DD"),
          })
          .then(({ data }) => {
            this.$store.commit("update_toast", ["已成功編輯筆記"]);

            this.$router.push(`/astroCalendar?date=${this.editDate}`);
          })
          .catch(() => {
            this.$messagePopup("儲存失敗", "請稍後再試", "了解", () =>
              this.$router.go(-1)
            );
          });
      }
    },
    async checkAleardyWrite(targetDate) {
      if (this.nowMode === "AstroCalendarNoteEdit") return false;
      let res = await this.$API.GET_CalendarNoteCheck({
        Date: targetDate || this.astroCalendarNoteEdit.Date,
      });
      if (res.data.Data) {
        this.showAlreadyWriteNotice = false;
      } else {
        this.showAlreadyWriteNotice = true;
      }
      return res.data.Data ? false : true;
    },
    saveDateTime() {
      // 日期範圍驗證
      const selectedDate = moment(this.temp_date);
      const startDate = moment("2026-04-01");
      const endDate = moment("2026-06-30");
      // 判斷日期是否小於 2026-01-01
      if (selectedDate.isBefore(startDate, "day")) {
        this.$messagePopup(
          "該年度沒有共時曆的內容",
          "2026 年共時曆僅收錄 4～12 月，<br>1～3 月沒有對應的內容喔。",
          "瞭解"
        );
        return;
      }

      // 判斷日期是否大於 2026-12-31
      if (selectedDate.isAfter(endDate, "day")) {
        this.$messagePopup(
          "年度共時曆準備中！",
          "2026 年共時曆 7～9 月及 10～12 月<br class='hidden-mobile-up'>的內容<br class='hidden-mobile-down'>會分兩批上架，敬請期待。",
          "瞭解"
        );
        return;
      }
      this.editDate = this.temp_date;
      this.dateModal = false;
      this.checkAleardyWrite(moment(this.temp_date).format("YYYY-MM-DD"));
      this.getTitleByDate();
    },
    moodsHandler(id) {
      let moodsArray = this.Moods ? this.Moods.split("|") : [];
      if (moodsArray.includes(id)) {
        moodsArray = moodsArray.filter((item) => item && item !== id);
      } else {
        moodsArray.push(id);
      }
      this.Moods = moodsArray.join("|");
    },
    // 編輯模式才使用
    async getEditData(CalendarNoteId) {
      try {
        let res = await this.$API.GET_CalendarNoteDetail(CalendarNoteId);
        this.$store.commit("setAstroCalendarNoteEdit", res.data.Data);
        this.temp_date = moment(res.data.Data.Date).format("YYYY-MM-DD");
      } catch (error) {
        console.log("get note error", error);
        this.$messagePopup("取得筆記失敗", "請稍後再試", "了解", () =>
          this.$router.go(-1)
        );
      }
    },
    // 取得當天Title
    async getTitleByDate() {
      try {
        let res = await this.$API.GET_CALENDAR_INTERPRETATION(
          this.astroCalendarNoteEdit.Date
        );
        this.currentInterpretation = res.data.Data;
      } catch (error) {
        console.error("取得筆記標題失敗", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixin.scss";
.calendarNoteCreate {
  max-width: 1024px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px auto;
  @include mobile {
    width: 100%;
    margin: auto;
  }
  &__title {
    width: 100%;
    font-weight: 500;
    font-size: 40px;
    line-height: 58px;
    color: $theme-color-2;
    display: flex;
    align-items: center;
    padding-bottom: 48px;
    img {
      width: 54px;
      margin-right: 16px;
      @include mobile {
        width: 30px;
        margin-right: 5px;
      }
    }
  }
  &__box {
    padding: 32px 60px 36px;
    width: 800px;
    min-height: 916px;
    box-shadow: 4px 4px 25px rgba(0, 0, 0, 0.3), -4px -4px 10px rgba(238, 109, 175, 0.22),
      -4px -4px 16px rgba(238, 109, 175, 0.22);
    border-radius: 20px;
    @include mobile {
      width: 100%;
      padding: 16px 24px 24px;
      min-height: 700px;
      box-shadow: unset;
    }
    &__detail {
      width: 100%;
      @include mobile {
        padding: 0 24px;
      }

      &__picArea {
        width: 120px;
        height: 120px;
        box-shadow: 4.75px 4.75px 11.88px 0px #00000033,
          -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22), -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22);

        border-radius: 50%;
        margin-bottom: 16px;
        margin: 0 auto;
        @include center;
        img {
          height: 80px;
          width: 80px;
          object-fit: cover;
          margin: 0 auto;
        }
        // 手機版微調
        @include mobile {
          width: 76px;
          height: 76px;
          img {
            width: 50px;
            height: 50px;
          }
        }
      }

      &__date {
        font-size: 22px;
        font-weight: 700;
        line-height: 28px;
        color: $secondary-color-1;
        margin-top: 16px;
        text-align: center;
        span {
          font-size: 16px;
          @include mobile {
            font-size: 14px;
          }
        }
        @include mobile {
          font-size: 18px;
          margin-top: 12px;
        }
      }

      &__highlight {
        margin-top: 8px;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
        color: $secondary-color-1;
        @include mobile {
          margin-top: 4px;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    &__switchDate {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      line-height: 30px;
      color: #868686;
      @include mobile {
        font-size: 16px;
        line-height: 24px;
      }
      &__btn {
        width: 92px;
        height: 28px;
        border-radius: 50px;
        box-shadow: 2px 2px 6px 0px #00000040, -1px -1px 4px 0px rgba(238, 109, 175, 0.22),
          -1px -1px 4px 0px rgba(238, 109, 175, 0.22);
        color: #ab956c;
        font-size: 14px;
        @include center;
        cursor: pointer;
        @include mobile {
          width: 82px;
          height: 28px;
          font-size: 12px;
        }

        img {
          width: 18px;
          height: 18px;
          margin-right: 4px;
          @include mobile {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
      }
    }

    &__line {
      margin-top: 24px;
      height: 3px;
      background: #f0f2f4;
      box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.08) inset,
        3px 3px 4px 0px rgba(238, 109, 175, 0.22);
    }
    &__input {
      margin-top: 20px;
      @include mobile {
        margin-top: 16px;
      }
      &__title {
        color: #9b9b9b;
        font-size: 18px;
        line-height: 26px;
        margin-bottom: 12px;
        @include mobile {
          font-size: 16px;
          line-height: 28px;
          margin-bottom: 8px;
        }
      }
      //Select Moods
      &__selectEmotion {
        display: flex;
        margin-bottom: 20px;
        max-width: calc(100vw - 48px);
        @include mobile {
        }
        &__item {
          display: flex;
          flex-direction: column;
          margin-right: 24px;
          justify-content: center;
          @include mobile {
            margin-right: min(24px, 5%);
          }
          &__pic {
            flex-shrink: 0;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.25),
              -1px -1px 4px 0px rgba(238, 109, 175, 0.22), -1px -1px 4px 0px rgba(238, 109, 175, 0.22);
            @include center;
            cursor: pointer;

            &.active {
              background-color: #fff;
            }
          }
          &__label {
            font-size: 14px;
            line-height: 28px;
            font-size: 14px;
            color: #868686;
            text-align: center;
            @include mobile {
              margin-top: 4px;
              font-size: 12px;
              line-height: 20px;
            }
          }
        }
      }

      .detail {
        width: 100%;
        height: 480px;
        border-radius: 8px;
        box-shadow: inset 2px 2px 4px 0 rgba(0, 0, 0, 0.15),
          2px 2px 4px 0 rgba(238, 109, 175, 0.22);
        background-color: #f0f2f4;
        lighting-color: 28px;
        font-size: 18px;
        letter-spacing: 1.08px;
        color: #17445c;
        padding: 16px;
        resize: none;
        @include mobile {
          height: 439px;
          padding: 12px;
        }
        &::-webkit-scrollbar {
          height: 2px;
          width: 2px;
          transform: translateX(-2px);
          // background: #00f;
        }

        &::-webkit-scrollbar-thumb {
          background: #868686;
        }

        &:focus {
          border: none;
          outline: none;
        }
        &::placeholder {
          color: #2929293a;
        }
      }
      .detail.area1 {
        height: 138px;
        @include mobile {
          height: 195px;
        }
      }
      .detail.area2 {
        height: 480px;
        @include mobile {
          height: 439px;
        }
      }
      span {
        display: flex;
        margin-top: 4px;
        width: 100%;
        justify-content: flex-end;
        color: #9b9b9b;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 1.12px;
        @include mobile {
          margin-top: 0px;
        }
      }
    }
    &__notice {
      margin-top: 20px;
      height: auto;
      padding: 26px 24px;
      border: 1px solid #d2d2d2;
      border-radius: 20px 35px 20px 35px;
      color: #868686;
      display: flex;
      align-items: flex-start;
      img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
      span {
        color: $theme-color-2;
      }
      @include mobile {
        align-items: flex-start;
        padding: 16px 12px;
        font-size: 14px;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    &__btn {
      margin-top: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      @include mobile {
        justify-content: space-between;
      }
      &__ok {
        @include btn-default(176px, 56px, 20px);
        font-size: 20px;
        line-height: 30px;
        border: 2px solid rgba(121, 141, 165, 0.3);
        margin-right: 16px;
        text-align: center;
        color: #ffffff;
        margin-left: 15px;
        @include mobile {
          height: 40px;
          font-size: 14px;
          line-height: 21px;
        }
        &.disable {
          background-color: #9b9b9b;
          color: #fff;
          font-weight: 400;
          pointer-events: none;
        }
      }
      &__cancel {
        @include btn-default(176px, 56px, 20px);
        font-size: 20px;
        line-height: 30px;
        transition: 0.2s;
        color: #9b9b9b;
        background: transparent;
        border: 1px solid #9b9b9b;
        &:hover {
          color: #9b9b9b;
          background: transparent;
          border: 1px solid #9b9b9b;
        }
        @include mobile {
          height: 40px;
          font-size: 14px;
          line-height: 21px;
        }
      }
    }
  }
}
</style>
